module.exports = require("./../internal/prefix") + "version";
